import React from 'react';
import './FinalCTA.css';
import DownloadButton from '../../shared/DownloadButton';

const FinalCTA = () => (
  <section className="final-cta">
    <div className="final-cta-bg"></div>
    <h2 className="reveal">Your money,<br/><span className="grad-text">moving smarter</span></h2>
    <p className="reveal rd1">Download SequPay free — available now on Android. iOS coming soon.</p>
    <div className="final-cta-btns reveal rd2">
      <DownloadButton />
    </div>
  </section>
);

export default FinalCTA;
